import React, { createContext, useContext, useEffect, useState } from 'react';
import { API_BASE_URL } from '../../utils/apiConfig';
const StudentEnrollmentFormContext = createContext();

export const StudentEnrollmentFormProvider = ({ id, email, children }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!id && !email) {
      setLoading(false);
      return;
    }
    

    
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        let response;
        if (id) {
          // Use the new endpoint that accepts ID
          response = await fetch(`${API_BASE_URL}/students/enrollment-forms-by-id/${id}`);
        } else {
          // Fallback to email endpoint for backward compatibility
          response = await fetch(`${API_BASE_URL}/students/enrollment-forms/${email}`);
        }
        const result = await response.json();
        
        if (result.success) {
          setData(result.student);
        } else {
          setError(result.message || 'Student not found');
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setError('Error loading student information');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id, email]);
console.log("Enrollment Form Data",data);

  return (
    <StudentEnrollmentFormContext.Provider value={{ data, loading, error }}>
      {children}
    </StudentEnrollmentFormContext.Provider>
  );
};

export const useEnrollmentFormData = () => useContext(StudentEnrollmentFormContext); 